// 9fbef606107a605d69c0edbcd8029e5d
import { useEffect, useState } from 'react';
import { calculateLayout } from '../utils/ShopByLookStylitics.util';

const useLayoutObserver = (containerRef, carouselContent) => {
  const [layout, setLayout] = useState(null);

  useEffect(() => {
    const updateLayout = () => {
      const parentWidth = containerRef.current?.parentElement?.offsetWidth || window.innerWidth;
      if (parentWidth) {
        setLayout(calculateLayout(carouselContent.length, parentWidth));
      }
    };

    updateLayout();

    const observer = new ResizeObserver(updateLayout);
    if (containerRef.current) observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [carouselContent.length, containerRef, calculateLayout]);

  return layout;
};

export default useLayoutObserver;
